import React from 'react'
import { Page, Document, StyleSheet, Image, View} from '@react-pdf/renderer';
import InvoiceItemsTable from './pdf/InvoiceItemsTable';
import InvoiceTitle from './pdf/InvoiceTitle';
import Sign from './pdf/sign';
import InvoiceItemsTableList from './pdf/InvoiceItemsTableList';
import { Hidden } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';



function getRealAge(dateString) {
    
    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}

export default function HistoryMedicalPDF(props) {
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Helvetica',
            fontSize: 9,//11
            paddingTop: 30,
            paddingLeft:60,
            paddingRight:60,
            lineHeight: 1.5,
            flexDirection: 'column',
        }, 
        logo: {
            width: '100%',
            height: 'auto',
            //marginLeft: 'auto',
            //marginRight: 'auto'
        }
      }); 

      const  hideBarthel = ( score) => {
          let hidePage = Number(score) === -1;
          return hidePage
      }

     let originInfo = props.affiliateInfo.evolutions;
     
     if (props.printAdditionalInfo) {
        originInfo =  props.affiliateInfo.additionalsInfo;
     }
     const personalInfo = [
        {
           id: 1,
           key: "NOMBRE:",
           value: props.affiliateInfo.patient.firstName + " "  +
               `${props.affiliateInfo.patient.secondName || ''}` + " "  +
                props.affiliateInfo.patient.lastName + " "  +
               `${props.affiliateInfo.patient.secondLastName || ''}` 
        },
        {
           id: 2,
           key: "TIPO IDENTIFICACIÓN:",
           value: props.affiliateInfo.patient.typeId
       },
        {
            id: 3,
            key: "IDENTIFICACIÓN:",
            value: props.affiliateInfo.patient.id
        },
        {
            id: 4,
            key: "EPS:",
            value: props.affiliateInfo.patient.eps
        },
        {
           id: 5,
           key: "REGIMEN:",
           value: props.affiliateInfo.patient.regimen
       },
        {
            id: 6,
            key: "EDAD:",
            value: getRealAge(props.affiliateInfo.patient.birthday)
        },
       
        {
            id: 6,
            key: "TELEFONO:",
            value: props.affiliateInfo.patient.cellphone
        },
    
        {
            id: 7,
            key: "DIRECCION:",
            value: props.affiliateInfo.patient.address
        },
    
        {
            id: 8,
            key: "MUNICIPIO:",
            value: props.affiliateInfo.patient.residenceCode
        }
       ]

    const generalities = [
        {
            id: 1,
            key: "MOTIVO DE LA CONSULTA:",
            value: originInfo[props.indexEvolution].generalities.reason
        },
        {
            id: 2,
            key: "ENFERMEDAD ACTUAL:",
            value: originInfo[props.indexEvolution].generalities.illness
        },
        {
            id: 3,
            key: "CAUSA EXTERNA:",
            value: originInfo[props.indexEvolution].generalities.externalCause
        }
    ]

    const habits = [
        {
            id: 1,
            key: "ALCOHOL:",
            value: props.affiliateInfo.habits.alcohol
        },
        {
            id: 2,
            key: "CIGARRILLO/ ABACO:",
            value: props.affiliateInfo.habits.smokes
        },
        {
            id: 3,
            key: "DROGAS:",
            value: props.affiliateInfo.habits.drugs
        },
        {
            id: 4,
            key: "OTROS:",
            value: props.affiliateInfo.habits.others
        }
    ]

    const gineco = [
        {
            id: 1,
            key: "MENARQUIA:",
            value: props.affiliateInfo.gineco.menarquia
        },
        {
            id: 2,
            key: "CICLOS:",
            value: props.affiliateInfo.gineco.ciclos
        },
        {
            id: 3,
            key: "FUM:",
            value: props.affiliateInfo.gineco.fum
        },
        {
            id: 4,
            key: "GRAVIDA:",
            value: props.affiliateInfo.gineco.gravida
        },
        {
            id: 5,
            key: "PARTOS:",
            value: props.affiliateInfo.gineco.partos
        },
        {
            id: 6,
            key: "ABORTOS:",
            value: props.affiliateInfo.gineco.abortos
        },
        {
            id: 7,
            key: "CESAREA:",
            value: props.affiliateInfo.gineco.cesarea
        },
        {
            id: 8,
            key: "DISMENORREA:",
            value: props.affiliateInfo.gineco.dismenorrea
        },
        {
            id: 9,
            key: "COMP. SEX ULT AÑO:",
            value: props.affiliateInfo.gineco.quantityMen
        },
        {
            id: 10,
            key: "ANTECEDENTES DE EPI:",
            value: props.affiliateInfo.gineco.epi
        },
        {
            id: 11,
            key: "LACTANDO:",
            value: props.affiliateInfo.gineco.lactando
        },
        {
            id: 12,
            key: "DESEA MAS HIJOS:",
            value: props.affiliateInfo.gineco.moreKids
        },
        {
            id: 13,
            key: "ENF. TRAS. SEXUAL:",
            value: props.affiliateInfo.gineco.sexualIlness
        },
        {
            id: 14,
            key: "OTROS:",
            value: props.affiliateInfo.gineco.others
        }
    ]
       
    const familyBackground = [
        {
            id: 1,
            key: "DIABETES:",
            value: props.affiliateInfo.familyBackground.diabetes
        },
        {
            id: 2,
            key: "HIPERTENSIÓN:",
            value: props.affiliateInfo.familyBackground.hypertension
        },
        {
            id: 3,
            key: "SÍNDROME CONVULSIVO:",
            value: props.affiliateInfo.familyBackground.convulsive
        },
        {
            id: 4,
            key: "MALFORMACIONES:",
            value: props.affiliateInfo.familyBackground.malformations
        },
        {
            id: 5,
            key: "CANCER:",
            value: props.affiliateInfo.familyBackground.cancer
        },
        {
            id: 6,
            key: "OTROS:",
            value: props.affiliateInfo.familyBackground.others
        }
    ]
    const personalBackground = [
        {
            id: 1,
            key: "ENF. TROMBOTICA:",
            value: props.affiliateInfo.personalBackground.thrombotics
        },
        {
            id: 2,
            key: "CONVULSIONES:",
            value: props.affiliateInfo.personalBackground.convulsive
        },
        {
            id: 3,
            key: "DIABETES:",
            value: props.affiliateInfo.personalBackground.diabetes
        },
        {
            id: 4,
            key: "VALVULOPATIAS:",
            value: props.affiliateInfo.personalBackground.valveDisease
        },
        {
            id: 5,
            key: "ENF. HEPÁTICA:",
            value: props.affiliateInfo.personalBackground.hepatic
        },
        {
            id: 6,
            key: "CEFALEA:",
            value: props.affiliateInfo.personalBackground.cefalea
        },
        {
            id: 7,
            key: "HIPERTENSIÓN:",
            value: props.affiliateInfo.personalBackground.hypertension
        },
        {
            id: 9,
            key: "PATOLOGÍA MAMARIA:",
            value: props.affiliateInfo.personalBackground.breastPathology
        },
        {
            id: 10,
            key: "OTROS:",
            value: props.affiliateInfo.personalBackground.others
        }
    ]
    const reviewSystem = [
        {
            id: 1,
            key: "1. SÍNTOMAS GENERALES:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.generalSymptoms
        },
        {
            id: 2,
            key: "2. SISTEMA RESPIRATORIO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.respiratorySystem
        },
        {
            id: 3,
            key: "3. SISTEMA CARDIOVASCULAR:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.cardiovascularSystem
        },
        {
            id: 4,
            key: "4. SISTEMA GASTROINTESTINAL",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.gastrointestinalSystem
        },
        {
            id: 5,
            key: "5. SISTEMA GENITOURINARIO",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.genitourinarySystem
        },
        {
            id: 6,
            key: "6. SISTEMA ENDOCRINO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.endocrineSystem
        },
        {
            id: 7,
            key: "7. SISTEMA NEUROLOGICO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.neurologicalSystem
        }
    ]
    const reviewSystemFisiatria = [
        {
            id: 1,
            key: "1. Revision de Sistemas:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].systemsReview.generalSymptoms
        }
    ]
    const vitalSigns = [
        {
            id: 1,
            key: "PRESIÓN ARTERIAL:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.hhpressure + " Mm hg"
               
        },
        {
            id: 2,
            key: "FC:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.heartRate
        },
        {
            id: 3,
            key: "FR:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.breathingFrequency
        },
        {
            id: 4,
            key: "TEMPERATURA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.temperature
        },
        {
            id: 5,
            key: "TALLA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.size
        },
        {
            id: 6,
            key: "PESO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.weight
        },
        {
            id: 7,
            key: "P. CEFÁLICO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.headCircunference
        },
        {
            id: 8,
            key: "P. ABDOMINAL:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.abdominalPerimeter
        },
        {
            id: 9,
            key: "P. BRAQUIAL",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.brachialPerimeter
        },
        {
            id: 10,
            key: "I.M.C:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.imc
        }
    ]
    const physicalExam = [
        {
            id: 1,
            key: "1. ASPECTO GENERAL:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.generalAspect
        },
        {
            id: 2,
            key: "2. ESTADO EN EL QUE LLEGÓ:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.state
        },
        {
            id: 3,
            key: "3. CABEZA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.head
        },
        {
            id: 4,
            key: "4. AGUDEZA VISUAL:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.visualAcuity
        },
        {
            id: 5,
            key: "5. CUELLO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.neck
        },
        {
            id: 6,
            key: "6. TORAX:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.chest
        },
        {
            id: 7,
            key: "7. ABDOMEN:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.abdomen
        },
        {
            id: 8,
            key: "8. GENITOURINARIO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.genitourinary
        },
        {
            id: 9,
            key: "9. OSTEOMUSCULAR:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.musculoskeletal
        },
        {
            id: 10,
            key: "10. PIEL Y FAERAZ:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.skin
        },
        {
            id: 11,
            key: "11. NEUROLÓGICO:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].physicalExam.neurological
        }
        
    ]

    const plan = [
        {
            id: 1,
            key: "DESCRIPCIÓN DEL PLAN:",
            value: originInfo[props.indexEvolution].plan.descriptions
        },
        {
            id: 2,
            key: "OBSERVACIONES:",
            value: originInfo[props.indexEvolution].plan.observations
        }
    ]

    const scoreScalas = [
        {
            id: 1,
            key: "Puntaje Scala FAC:",
            value: originInfo[props.indexEvolution].scoreFAC
        },
        {
            id: 2,
            key: "Puntaje Scala Karnofsky:",
            value: originInfo[props.indexEvolution].scoreKarnofsky
        }
    ]

    const diagnoses = [['#',"CIE10", "DESCRIPCIÓN",  "CLASE DIAGNOSTICO"] ]
    originInfo[props.indexEvolution].diagnoses.map( (item, index) => {
        diagnoses.push([index + 1, item.id, item.description, item.classDiagnosis ])
    }
    )

    const remisiones = []
     originInfo[props.indexEvolution].referrals.map( (item, index) => 
     remisiones.push(
     {
        id: index,
        key: "REMITIDO A:",
        value: item.description
     },
     {
        id: index + 20,
        key: "OBSERVACIONES:",
        value: item.observations
     }
    )
    )


  

    const treatments = [['#',"CANTIDAD", "MEDICAMENTO",  "FORMULA"] ]
    originInfo[props.indexEvolution].treatments.map( (item, index) => {
        treatments.push([index + 1, item.quantity, item.description, 
     "Cada " +item.every +" " + item.everyTime+ " durante "+ item.duration + " " + item.durationTime ])
    }
    )
    
    let dateAttend = originInfo[props.indexEvolution].assessmentDate;
    let titlePDF = props.affiliateInfo.type !="Fisiatria" ? 'CONTROL - CONSULTA MÉDICA DOMICILIARIA' : "Fisiatría";
   if (props.affiliateInfo.type == "Neurología") {
        titlePDF = 'Neurología'
   }
    if (props.affiliateInfo.type =="Fisiatria") {
       let signosVitales ={
            id: 12,
            key: "12. SIGNOS VITALES:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.hhpressure
        }
        let gonometriPasive ={
            id: 13,
            key: "13. GONOMETRIA PASIVA:",
            value: props.printAdditionalInfo ? "" : props.affiliateInfo.evolutions[props.indexEvolution].vitalSigns.pressureMM
        }
        physicalExam.push(signosVitales)
        physicalExam.push(gonometriPasive)
        
    }
    return (
        <Document title={"HC_" + personalInfo[0].value + "_" + moment(dateAttend).locale('es').format('MMMM D YYYY')}>
     <Page size="A4" style={styles.page}>
        <View fixed>
        <Image style={styles.logo} src="https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/logo_pdf_2.png"></Image>
        </View>
               
                <InvoiceTitle title={titlePDF} dateAttend={originInfo[props.indexEvolution].assessmentDate}/>
                <InvoiceItemsTable items={personalInfo} title={"DATOS DE IDENTIFICACION DEL USUARIO"}  separator={2} />
                <InvoiceItemsTable items={generalities} title={"GENERALIDADES DE LA CONSULTA"}  separator={1} />
                <InvoiceItemsTable items={familyBackground} title={"ANTECEDENTES FAMILIARES"}  separator={3} />
                <InvoiceItemsTable items={personalBackground} title={"ANTECEDENTES PERSONALES"}  separator={4} lastAttribute100={true} />
                <Hidden xsUp={!(props.affiliateInfo.gineco.menarquia) && !(props.affiliateInfo.gineco.abortos)  && !(props.affiliateInfo.gineco.cesarea) }>
                <InvoiceItemsTable items={gineco} title={"ANTECEDENTES GINECO - OBSTETRICO"}  separator={3} />
                </Hidden>
                <InvoiceItemsTable items={habits} title={"HÁBITOS"}  separator={3} />
                <Hidden xsUp={props.affiliateInfo.type != "Fisiatria"}>
                        <InvoiceItemsTable items={reviewSystemFisiatria} title={"REVSIÓN POR SISTEMAS"}  separator={1} />
                    </Hidden>
                <Hidden xsUp={props.printAdditionalInfo}>
                    <Hidden xsUp={props.affiliateInfo.type == "Fisiatria"}>
                        <InvoiceItemsTable items={reviewSystem} title={"REVSIÓN POR SISTEMAS"}  separator={1} />
                        <InvoiceItemsTable items={vitalSigns} title={"SIGNOS VITALES"}  separator={2} />
                    </Hidden>
                    <InvoiceItemsTable items={physicalExam} title={"EXAMEN FÍSICO"}  separator={1} />
                </Hidden>
                <Hidden xsUp={(originInfo[props.indexEvolution]?.scoreKarnofsky == "No aplica") && (originInfo[props.indexEvolution]?.scoreFAC == "No aplica") }>
                <InvoiceItemsTable items={scoreScalas} title={"SCALAS"}  separator={3} />
                </Hidden>
               
                <InvoiceItemsTableList items={diagnoses} title={"IMPRESIÓN DIAGNÓSTICA"}  separator={2} />
                <InvoiceItemsTable items={plan} title={"PLAN"}  separator={1} />
                <InvoiceItemsTableList items={treatments} title={"ORDEN DE MEDICAMENTOS E INDICACIONES"}  separator={2} />
                <InvoiceItemsTable items={remisiones} title={"REMISIÓN(ES)"}  separator={1} />
               {/* <InvoiceItemsTable items={personalInfo} title={"ADICIONAL"}  separator={2} />*/}
               
                <Sign medical={props.affiliateInfo.medicalTeam} patient={props.affiliateInfo.patient} />
            </Page>

          </Document>
        )
    };